import { render, staticRenderFns } from "./theDocClaimsModal.vue?vue&type=template&id=aa034524&"
import script from "./theDocClaimsModal.vue?vue&type=script&lang=js&"
export * from "./theDocClaimsModal.vue?vue&type=script&lang=js&"
import style0 from "./theDocClaimsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports